import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRightLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowRightLeft"><Path d="M7.5 20.5L3.5 16.5L7.5 12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 11.5L20.5 7.5L16.5 3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4 16.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 7.5H20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowRightLeft;
